import { iconPropColor } from "../../types/IconComponent";
export var getColor = function getColor(color) {
  if (iconPropColor.includes(color)) {
    return "var(--icon-color-".concat(color, ")");
  }
  if (color.includes('--') && !color.includes('var')) {
    return "var(".concat(color, ")");
  }
  return color;
};